var appConfig = window.APP_CONFIG || {};
var apiBase = appConfig.API_ENDPOINT;

if (!apiBase) {
    document.title = '[MISSING CONFIG] ' + document.title;
    window.history.replaceState(
        {},
        '',
        window.location.pathname + window.location.search + '#missing-app-config'
    );

    throw new Error('Missing required config: window.APP_CONFIG.API_ENDPOINT');
}

export const environment = {
    production: true,
    version: '1.0.53',
    API_ENDPOINT: apiBase + '/BigRedSkyOnboarding/OnboardingPortalAPI/web/index.php/api/',
    platform: '',
    gaID: 'UA-102615324-1'
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts